export default `#include <color_fragment>
diffuseColor.rgb = terrainTint(vWorldPos);`